import type { ReactNode } from 'react';
import type { IconProps } from './types.js';

interface SvgInternalProps extends IconProps {
  children: ReactNode;
  iconName: string;
}

export function Svg(props: SvgInternalProps): ReactNode {
  const { size = 16, className, title, iconName, name, children, style, ...rest } = props;
  const resolvedName = name ?? iconName;
  const hasTitle = title !== undefined && title !== '';
  const classes = ['vq-icon', `vq-icon-${resolvedName}`, className ?? '']
    .filter((part) => part !== '')
    .join(' ');
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={classes}
      role={hasTitle ? 'img' : undefined}
      aria-hidden={hasTitle ? undefined : true}
      aria-label={hasTitle ? title : undefined}
      focusable={false}
      style={style}
      {...rest}
    >
      {hasTitle ? <title>{title}</title> : null}
      {children}
    </svg>
  );
}
